import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { laboratoryService } from 'shared/services';
import { Option } from 'shared/types/general';
import { ILISTranscode } from '../types';

interface LISTranscodesFormParams {
  lisTranscode: ILISTranscode;
  onSubmit: any;
}

function LISTranscodesForm({ onSubmit, lisTranscode }: LISTranscodesFormParams) {
  const { t } = useTranslation();

  const [laboratories, setLaboratories] = useState<Option[]>([]);

  useEffect(() => {
    laboratoryService.getAllBaseInformation().then(setLaboratories);
  }, []);

  return (
    <div>
      {lisTranscode && (
        <EnhancedForm onSubmit={onSubmit} autoStyleLayout columns={2}>
          <IdentityField
            name="laboratory"
            component={AutocompleteAdapter}
            options={laboratories}
            initValue={lisTranscode.laboratory}
            label={t('global.laboratory')}
            type="text"
          />
          <IdentityField
            name="transcode"
            initialValue={lisTranscode.transcode}
            component={TextFieldAdapter}
            label={t('global.transcode')}
            type="text"
            required
          />
        </EnhancedForm>
      )}
    </div>
  );
}

export default LISTranscodesForm;
